import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseEventOrganizationCalling } from 'entities/Organization/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventOrganizationCalling = () => {
  const { organizationStore, websocket } = useEntitiesContext()
  const handle = (data: IResponseEventOrganizationCalling) => {
    organizationStore.updateOrganizationCall(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.OrganizationCalling, handle), [])
}
